import { EventState, EventData } from './types';

const defaultState = {};

const getEventsById = (eventsQueue: EventState, id: string): EventData =>
    eventsQueue && eventsQueue.byIds[id] ? eventsQueue.byIds[id] : defaultState;

export default getEventsById;
